import { messages } from '@custom/locales';
import {
  coursesBasePaths,
  sirmedCoursesBasePaths,
  sirmedCoursesFirstAidBasePaths,
  sirmedCoursesProfessionalsBasePaths,
} from '@custom/schema/learning-platform-paths';

import type { Locale } from './locales';

// Assembles the i18next resource tree from the shared @custom/locales package.
// Shape is preserved for backwards compatibility: gatsby-node reads urls via
// `get(translations, '<locale>.urls.<key>')` and i18next uses the `translation`
// namespace, so the shared `common` bundle is mapped onto `translation` here.
//
// The dynamic learning-platform course paths are layered in here (not in
// @custom/locales) on purpose: keeping the shared package free of a
// @custom/schema dependency preserves the storybook topology and avoids a
// circular-init error when Gatsby bundles the package into gatsby-node.js.
const urlsFor = (locale: Locale) => ({
  ...messages[locale].urls,
  courses: coursesBasePaths[locale],
  sirmedCourses: sirmedCoursesBasePaths[locale],
  sirmedCoursesProfessionals: sirmedCoursesProfessionalsBasePaths[locale],
  sirmedCoursesFirstAid: sirmedCoursesFirstAidBasePaths[locale],
});

export const translations = {
  default: {},
  en: { urls: urlsFor('en'), translation: messages.en.common },
  de: { urls: urlsFor('de'), translation: messages.de.common },
  fr: { urls: urlsFor('fr'), translation: messages.fr.common },
  it: { urls: urlsFor('it'), translation: messages.it.common },
};
